import { useState, useCallback } from 'react';
import * as tracking from 'dibs-tracking';

const ITEMS_REFETCH_LIMIT = 4;

type PaginationHooks = {
    onClickArrow: (direction: string) => void;
    onCarouselReset: () => void;
};

export const usePaginationHooks = (
    loadNext: (count: number) => void,
    options?: { itemsRefetchLimit?: number; label?: string; action?: string; category?: string }
): PaginationHooks => {
    const {
        itemsRefetchLimit = ITEMS_REFETCH_LIMIT,
        label = 'pdp carousel',
        action = 'pdp module arrow click',
        category = 'product',
    } = options || {};
    const [hasFetchedAllImages, setHasFetchedAllImages] = useState(false);
    const onClickArrow = useCallback(() => {
        if (!hasFetchedAllImages) {
            setHasFetchedAllImages(true);
            loadNext(itemsRefetchLimit);
        }
        tracking.trackEvent(
            {
                label,
                category,
                isInteractiveEvent: true,
                action,
            },
            null
        );
    }, [hasFetchedAllImages, itemsRefetchLimit, loadNext, label, action, category]);

    const onCarouselReset = useCallback(() => {
        setHasFetchedAllImages(false);
    }, []);

    return {
        onClickArrow,
        onCarouselReset,
    };
};
